import Request, { APIS } from './Request';
import FormatDate from './FormatDate';

const timeout = 30000;

function MultipleRequests(departmentId, requestDates) {
    if (!(requestDates instanceof Array)) throw new Error("Not an array");

    const responses = [];

    requestDates.forEach(date => {
        const from = date.from;
        const to = date.to;

        if (!(from instanceof Date) || !(to instanceof Date)) throw new Error("Not a date");

        var headers = {
            from: FormatDate(from),
            to: FormatDate(to)
        }

        if (departmentId) headers.departmentId = departmentId;

        Request(APIS.Salestat, headers).then(data => responses.push(data));
    });

    return new Promise((res, rej) => {
        setTimeout(() => rej("Timed out"), timeout);

        var interval;

        function readyCheck() {
            if (responses.length >= requestDates.length) {
                res(responses);
                clearInterval(interval);
            }
        }

        interval = setInterval(readyCheck, 100);
    });
}

export default function GetSalesData(departmentId, from, to, preset) {
    if ((!preset && !(from instanceof Date) && !(to instanceof Date))) throw new Error("One or both arguments are not dates");

    const now = new Date();

    const nowYear = now.getFullYear();
    const nowMonth = now.getMonth();
    const nowDate = now.getDate();

    const dates = [];

    switch(preset) {
        default:
            return Request(APIS.Salestat, {from: FormatDate(from), to: FormatDate(to)});
        
        case 'This week':
            for (let i = 0; i < 7; i++) {
                const dateTo = new Date(nowYear, nowMonth, nowDate - i);

                // We're only getting one day, so we use the same date
                const dateFrom = dateTo;

                dates.push({from: dateFrom, to: dateTo});
            }
        break;
        
        case 'This month':
            for (let i = 0; i < 4; i++) {
                const dateTo = new Date(nowYear, nowMonth, nowDate - 7 * i);
                
                const dateFrom = new Date(
                    dateTo.getFullYear(),
                    dateTo.getMonth(),
                    dateTo.getDate() - 6
                );

                dates.push({from: dateFrom, to: dateTo});
            }
        break;

        case 'This year':
            for (let i = 0; i < 12; i++) {
                const dateTo = new Date(nowYear, nowMonth - i, nowDate);

                const dateFrom = new Date(
                    dateTo.getFullYear(),
                    dateTo.getMonth() - 1,
                    dateTo.getDate() + 1
                );

                dates.push({from: dateFrom, to: dateTo});
            }
        break;
    }

    if (dates.length === 0) throw new Error("Preset not found");

    return MultipleRequests(departmentId, dates);
}


// WEBPACK FOOTER //
// ./src/js/GetSalesData.js